import React, { SyntheticEvent, useMemo, useRef } from "react";
import { useEffect, useState, useCallback } from "react"
import { Autocomplete, CircularProgress, ClickAwayListener, IconButton, Stack, TextField } from "@mui/material"
import Label from "../../../../common/components/Label"
import Grouped from "../../../../common/components/SearchAndSingleSelect"
import { useLazyGetLocationListQuery } from "../../../../redux/services/location"
import JobLocation from "./JobLocation";
import { useDispatch, useSelector } from "react-redux"
import { setJobLocation, setJobTitle, setCampaignTemplate, setTabStates, setCampaignName, setTempalteForCampaign, setErrorMessages, resetGeneratedAiButton, setTemplateSelected, setAboutCompany, setCompanyName, setMaxExperience, setMaxSalary, setMinExperience, setMinSalary, setReplyId, setFolderName, setFolderId, setIsCampaignTemplateClicked, setCompleteEmailReset, setAllFolders, setContentTypes } from "../../../../redux/slice/campaignSlice"
import { RootState } from "../../../../redux/store"
import { useGetCampaignTemplatesQuery, useGetJobTitleListMutation, useLazyGetAllFoldersQuery } from "../../../../redux/services/folderName"
import styled from "@emotion/styled";
import { COLOR_MAP } from "../../../../constants/ColorNames";
import { campaignPlaceholderMapping, placeholderMapping } from "../../../../constants/helpers";
import { prefillFields } from "../../../../utils/helpers";
import useDebounceValue from "../../../../hooks/useDebounceValue";
import { LabelValueType } from "../../../../types/dataTypes";
import { CROSS_ICON } from "../../../../constants/icons/CrossIcon";
import CLOSE_ICON from "../../../../constants/icons/CloseIcon";
import BasicModal from "../../../../common/components/Modal";
import { getRandomValue } from "../../../../utils/whatsAppUtils";

type CampaignTemplateType = {
  title: string,
  steps: number,
  value: any
}

const CampainName = styled.p`
  font-weight:400 ;
  font-size: 1.4rem;
  line-height: 2rem;
  color: ${COLOR_MAP.LIGHT_GREY};
  margin: 0;
`

const CampainSteps = styled.span`
  font-weight:400 ;
  font-size: 1.2rem;
  line-height: 1.6rem;
  color: ${COLOR_MAP.GREY_3};
`

const renderOptions = (props: object, option: any) => {
  return (
      <li {...props}>
          <CampainName>{option.title} <CampainSteps>({option.steps} steps)</CampainSteps></CampainName>
      </li>
  )
}
const LeftSideJob = () => {
  const isModalClosingRef = useRef(false);
  const [campaignInputValue, setCampaignInputValue] = useState<string>('')
  const [openResetModal, setOpenResetModal] = useState<boolean>(false)
  
  
  const dispatch = useDispatch();
  const jobTitle = useSelector((state: RootState) => state.campaign.jobTitle);
  const [designation, setDesignation] = React.useState<string>('');
    const errorMessages = useSelector((state: RootState) => state.campaign.errorMessages);
    const masterData = useSelector((state: RootState) => state.campaign.masterData);
    const campaignTemplate = useSelector((state: RootState) => state.campaign.campaignTemplate);
    const campaignName = useSelector((state: RootState) => state.campaign.campaignName);
    const isTemplateForCampaignUsed = useSelector((state: RootState) => state.campaign.isTemplateForCampaignUsed);
    const contentPersonalisationGenratedViaAI = useSelector((state: RootState) => state.campaign.contentPersonalisationGenratedViaAI);
    const campaignQueryData = useSelector((state: RootState) => state.campaign.campaignCreationQueryData);


    const [ triggerGetFolders, { data: foldersListData, isUninitialized: isFoldersUninitialized }] = useLazyGetAllFoldersQuery();
    const [ triggerGetJobList , { data: jobListData, isLoading: isFetchingJobList, isUninitialized: isJobLIstUninitialized }] = useGetJobTitleListMutation()
    
    const [trigger, { data }] =  useLazyGetLocationListQuery();
    const {data: campaignTemplateData } = useGetCampaignTemplatesQuery(1);

    const isBulkCampaign = campaignQueryData.isBulkCampaign === 'true' ? true : false;
    const triggeredFromPage = campaignQueryData.triggeredFromPage;

    const showContactedProfileOptions = isBulkCampaign && !triggeredFromPage;

    const formattedCampaignTemplateData = React.useMemo(()=> campaignTemplateData && campaignTemplateData.length ? 
    campaignTemplateData.map((item: any) => {
      return {'title': item.name, 'steps': item.steps.length, value: item.steps, type: item.standardTemplated? 'Standard': 'Recent', jobDescription: item?.jobDescription, folderDetails: item?.folderDetails}
    }
    ) : [] ,[campaignTemplateData]);

    const debouncedSearchValue = useDebounceValue(designation, 500);

    React.useEffect(() => {
      const random = getRandomValue();
      debouncedSearchValue && triggerGetJobList({jobTitle : debouncedSearchValue, random});
    },[debouncedSearchValue])

    useEffect(() => {
      if(jobTitle){
        setDesignation(jobTitle)
      }
    },[jobTitle])

    useEffect(() => {
        if(masterData.recruiterId){
          trigger(masterData)
        }
        
    }, [trigger, masterData, masterData.recruiterId]);
    
    useEffect(() => {
      if (isFoldersUninitialized) {
        triggerGetFolders()
        .unwrap().then((response) => { 
          dispatch(setAllFolders({ allFolders: response }))
        })
        .catch((error) => { 
          console.log('error', error)
        })
      }
    }, [triggerGetFolders, isFoldersUninitialized, dispatch]);

    const handleCampaignTemplateSelection = React.useCallback( async (event: any, value: any)=> {
      dispatch(resetGeneratedAiButton())
      dispatch(setTemplateSelected({ templateSelected: true }))
      if(value && value.title){
        dispatch(setCampaignName({ campaignName:  value?.title }));
        if (errorMessages.campaignName) {
          dispatch(setErrorMessages({ errorMessages: { campaignName: '' } }));
        }
      }
        !isTemplateForCampaignUsed && dispatch(setTempalteForCampaign({ isTemplateForCampaignUsed: true}));
      if(value && value.value && value.value.length){
        dispatch(setIsCampaignTemplateClicked({isCampaignTemplateClicked: true}))
      }
        
      const updatedTabState = (value && value.value) ? value.value.map((item:any,index: number) => {
        const label = index === 0 ? 'Email' : `Follow up-${index}`;
        let email = item.mailBody;
        let subject = item.mailSubject;

        Object.entries(placeholderMapping).forEach(([text, htmlContent]) => {
          let updatedText = text.split(':')[0];
 
          if (email.includes(updatedText)) {
            email= email.replace(updatedText, htmlContent);
          }
          if(subject.includes(updatedText)) {
            subject = subject.replace(updatedText, htmlContent);
          }
        });

        Object.entries(campaignPlaceholderMapping).forEach(([text, htmlContent]) => {
          if(email.includes(text)){
            email = email.replaceAll(text,htmlContent);
          }
          if(subject.includes(text)) {
            subject = subject.replace(text, htmlContent);
          }
        })
        email = email.replace(/\n<\/br>\n/g, '<div></div>');
        return {
          label: label,
          subject: subject,
          email: email,
          applyButton: item.attachApplyButton,
          replyButton: item.attachApplyButton,
          stepNumber: item.stepNumber+1,
          selectedFollowUPdays: item.activateAfterDays
        }
      }
    ) : [{
      label: 'Email',
      subject: '',
      email: '',
      applyButton: true,
      replyButton: true,
      selectedFollowUPdays: '0',
      stepNumber: 1,
    }]
    dispatch(setTabStates({ tabState: updatedTabState }));

    updatedTabState?.forEach((item:any)=>{
        dispatch(setContentTypes({tabIndex: item?.stepNumber, contentType: {
          contentType: "TEMPLATE",
          tabIndex: item?.stepNumber
        }}))
    })

    //folderName
    if(!showContactedProfileOptions){
      const fillFolder = async () => {
        const { folderid } = value?.folderDetails || {}
  
        let foldersList;
        if (!foldersListData) {
          foldersList = await triggerGetFolders().unwrap();
        } else {
          foldersList = foldersListData
        }
  
        const folderSelected = foldersList?.find((item: any) => item.folderId === folderid)
        dispatch(setFolderName({ folderName: folderSelected ? `${folderSelected?.type || ''} ${folderSelected?.name || ''} (${folderSelected?.num_profiles || 0})` : '' }));
        dispatch(setFolderId({ folderId: folderid }))
  
      } 
      if(value?.folderDetails) {
        await fillFolder()
      } 
      // else {
      //   dispatch(setFolderName({ folderName: '' }));
      //   dispatch(setFolderId({ folderId: '' }))
  
      // }
    }


    //job description
     if(value?.jobDescription) {
      const {jobTitle, jobLocations, minSalary, maxSalary, minExp, maxExp, aboutCompany, companyName, receiveReplyOnEmail, name } = value?.jobDescription || {}

      prefillFields(dispatch, [
        {value: receiveReplyOnEmail, key:'replyId', dispatchFunction: setReplyId},
        {value: jobTitle, key:'jobTitle', dispatchFunction: setJobTitle},
        {value: jobLocations, key:'jobLocation', dispatchFunction: setJobLocation},
        {value: name, key:'campaignName', dispatchFunction: setCampaignName},
        {value: minSalary?.toString(), key:'minSalary', dispatchFunction: setMinSalary},
        {value: maxSalary?.toString(), key:'maxSalary', dispatchFunction: setMaxSalary},
        {value: minExp?.toString(), key:'minExperience', dispatchFunction: setMinExperience},
        {value: maxExp?.toString(), key:'maxExperience', dispatchFunction: setMaxExperience},
        {value: companyName, key:'companyName', dispatchFunction: setCompanyName},
        {value: aboutCompany, key:'aboutCompany', dispatchFunction: setAboutCompany},
      ])
    }
    
    },[dispatch, isTemplateForCampaignUsed, showContactedProfileOptions, errorMessages.campaignName, foldersListData, triggerGetFolders])
    
    const handleCampaignTemplateInputChange = React.useCallback((event: any, value: any) => {
        setCampaignInputValue(value);
        dispatch(setCampaignTemplate({ campaignTemplate: value }));
        isTemplateForCampaignUsed && dispatch(setTempalteForCampaign({ isTemplateForCampaignUsed: false}));
    },[dispatch, isTemplateForCampaignUsed])


    const handleCreateClick = useCallback(() => {
        dispatch(setCampaignTemplate({ campaignTemplate: campaignInputValue }));
        dispatch(setCampaignName({ campaignName: campaignInputValue }));
        isTemplateForCampaignUsed && dispatch(setTempalteForCampaign({ isTemplateForCampaignUsed: false}));
    },[campaignInputValue, dispatch, isTemplateForCampaignUsed]);

    const handleJobTitleChange = (e: any,value: any) => {
      if (isModalClosingRef.current) {
        isModalClosingRef.current = false;
        return;
      }
      
      if(value) {
          setDesignation(value)
        } else {
          if(contentPersonalisationGenratedViaAI) {
            if(e && e.type !== 'blur') {
              setOpenResetModal(true)
            }
          } else {
            setDesignation(value)
          }
        }
        if (errorMessages?.jobTitle) {
          dispatch(setErrorMessages({ errorMessages: { jobTitle: '' } }));
        }
    }

    const handleDesignationUpdate = useCallback((event: SyntheticEvent<Element, Event>, value: any, reason: string) => {
      if(value){
           dispatch(setJobTitle({ jobTitle: value?.value}));
      }
    },[dispatch])

    const handleResetModalButton = () => {
      setOpenResetModal(false)
      dispatch(setCompleteEmailReset())
      dispatch(setJobTitle({ jobTitle: ''}))
      setDesignation('');
    }
    const handleResetModalCancel = () => {
      setOpenResetModal(false)
      isModalClosingRef.current = true;
    }
    
    return (
        <Stack rowGap='1rem'>
            <Stack rowGap='0.5rem'>
                <Label
                    colorType="light"
                    label="Designation"
                    required
                    labelFor="jobTitle"
                />
                <ClickAwayListener onClickAway={() => dispatch(setJobTitle({ jobTitle: designation}))}>
                <Autocomplete
                  disablePortal
                  popupIcon=""
                  clearIcon={CLOSE_ICON() as unknown as React.ReactNode}
                  freeSolo
                  id="combo-box-demo"
                  loading={isFetchingJobList}
                  options={jobListData || []}
                  inputValue={designation}
                  onInputChange={handleJobTitleChange}
                  onChange={handleDesignationUpdate}
                  sx={{
                    "&.MuiAutocomplete-root .MuiOutlinedInput-root:hover":{
                      paddingRight: "2.3rem !important",
                    },
                    "&.MuiAutocomplete-root .MuiOutlinedInput-root.Mui-focused":{
                      paddingRight: "2.3rem !important",
                    },
                  }}
                  renderInput={(params) => 
                  <TextField {...params} 
                  placeholder="Write job role here..."
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {isFetchingJobList ? <div style={{paddingRight: '12px'}}><CircularProgress color="inherit" size={20} /></div> : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                  error={Boolean(errorMessages?.jobTitle)}
                  helperText={errorMessages?.jobTitle || ""}
                  />
                }
                />
              </ClickAwayListener>
            </Stack>
            <Stack rowGap='0.5rem'>
                <Label
                    colorType="light"
                    label="Job mode & location"
                    required
                    labelFor="jobLocation"
                />
                <JobLocation OPTIONS_LIST={(data && data) || []} showError={Boolean(errorMessages.jobLocation)} errorMessage={errorMessages.jobLocation}/>
                {errorMessages?.jobLocation && (<div style={{color: 'red', fontFamily: "Noto Sans", fontSize: '1.2rem'}}>{errorMessages?.jobLocation}</div>)}
            </Stack>
            <Stack rowGap='0.5rem'>
                <Label
                    colorType="light"
                    label="Campaign template"
                    labelFor="campaignTemplate"
                />
                <Grouped
                    options={formattedCampaignTemplateData}
                    renderOption={renderOptions}
                    onValueSelect={handleCampaignTemplateSelection}
                    onInputChange={handleCampaignTemplateInputChange}
                    inputValue={campaignTemplate}
                    onCreateClick={handleCreateClick}
                    campaignName={campaignName}
                    disabled={!!contentPersonalisationGenratedViaAI}
                    // tooltip={!!contentPersonalisationGenratedViaAI? aiTab?.label === 'Email'? 'Email content has generated via ai' : `Follow up ${Number(aiTab?.stepNumber) - 1} content has been generated via ai` : ''}
                    tooltip={!!contentPersonalisationGenratedViaAI ? <div>Want a different approach? Click 'Reset' and choose your template!</div> : ''}
                    selectedValue={campaignTemplate}
                    />
            </Stack>
               <BasicModal
                    handleClose={handleResetModalCancel}
                    action='Yes!'
                    cancelAction='No'
                    flipActions={true}
                    handleAction={handleResetModalButton}
                    open={openResetModal}
                    heading='Are you Sure ?'
                    content={<div style={{paddingTop: '1.6rem' }}>Do you want to clear the AI based Mail content</div>}
                    />
        </Stack>

    )
}

export default LeftSideJob
